module.exports = __webpack_public_path__ + "static/media/bulle-chapeau.610fa918.png";